export default {
  delivered: {
    'link-feedback-popup': {
      title: 'Cảm ơn bạn đã sử dụng dịch vụ của chúng tôi và chúng tôi rất trân trọng phản hồi của bạn.',
      subtitle: 'Vui lòng để lại đánh giá trên trang Google của chúng tôi',
      btn: 'Đồng ý',
    },
    info: {
      'payment-delivered-title': 'Đã giao',
    },
    feedback: {
      title: 'Phản hồi của bạn rất quan trọng với chúng tôi',
      comment: {
        title: 'Vui lòng để lại nhận xét của bạn:',
        placeholder: 'Viết xuống nếu bạn hài lòng, kỳ vọng và cảm nhận của bạn',
        'send-btn': 'Gửi phản hồi',
        'change-btn': 'Thay đổi phản hồi',
        'not-send-tooltip': {
          text: 'Liên hệ với tôi',
          title: 'Dịch vụ khách hàng sẽ gọi cho bạn',
          content: 'Vui lòng để lại phản hồi của bạn, và nhân viên dịch vụ khách hàng sẽ liên hệ với bạn trong thời gian sớm nhất.',
        },
      },
      suggestions: {
        driver: {
          positive: {
            'went-above-and-beyond': 'Vượt trên mong đợi',
            'professional-appearance': 'Ngoại hình chuyên nghiệp',
            'courteous-and-respectful': 'Lịch sự và tôn trọng',
            'on-time-delivery': 'Giao hàng đúng giờ',
          },
          negative: {
            'unfriendly-driver': 'Tài xế không thân thiện',
            'did-not-follow-instructions': 'Không làm theo hướng dẫn',
            'late-delivery': 'Giao hàng trễ',
            'unprofessional-appearance': 'Ngoại hình không chuyên nghiệp',
          },
        },
        dispatcher: {
          positive: {
            'great-communication': 'Giao tiếp tốt',
            'patient-and-understanding': 'Kiên nhẫn và thấu hiểu',
            'efficient-coordination': 'Phối hợp hiệu quả',
            'quick-response-time': 'Phản hồi nhanh',
          },
          negative: {
            'impatient-or-rude': 'Thiếu kiên nhẫn hoặc thô lỗ',
            'poor-coordination': 'Phối hợp kém',
            'failed-to-address-concerns': 'Không giải quyết được vấn đề',
            'slow-response-time': 'Phản hồi chậm',
          },
        },
        pharmacy: {
          positive: {
            'friendly-staff': 'Nhân viên thân thiện',
            'secure-packaging': 'Đóng gói an toàn',
            'fast-shipping': 'Giao hàng/Nạp thuốc nhanh',
            'concise-medication-instructions': 'Hướng dẫn dùng thuốc rõ ràng',
          },
          negative: {
            'difficult-to-open': 'Khó mở',
            'incorrect-prescription': 'Đơn thuốc sai',
            'unfriendly-staff': 'Nhân viên không thân thiện',
            'wrong-medication': 'Thuốc sai',
          },
        },
      },
    },
  },
  delivering: {
    confirmed: {
      'stops-away': 'dừng cách đây',
      'your-stop-is-next': 'Điểm xuống tiếp theo của bạn',
      'special-instruction': {
        title: 'Hướng dẫn đặc biệt của nhà thuốc:',
        'new-instruction-input': {
          title: 'Hướng dẫn đặc biệt cho người nhận',
          placeholder: 'Thêm hướng dẫn đặc biệt',
        },
        'new-instruction-btn-save': 'Lưu',
        'not-editable-warning': 'Xin lỗi, bạn không thể thay đổi hướng dẫn đặc biệt vì tài xế đã gần đến.',
      },
      'arriving-data': {
        today: {
          'label-2': 'Giao hôm nay',
          label: 'Thời gian giao ước tính',
        },
        next: {
          label: 'Tài xế sẽ đến trong',
          time: 'Vài phút nữa',
        },
        'few-minutes': {
          'label-2': 'Tài xế sẽ đến trong',
        },
      },
      qr: {
        info: 'Hiển thị mã QR cho tài xế',
        description: 'Để nhận đơn hàng, hãy cho tài xế xem mã QR hoặc gọi mã',
        help: 'Copay là khoản tiền cố định bạn phải trả cho các dịch vụ chăm sóc sức khỏe hoặc đơn thuốc được bảo hiểm theo kế hoạch của bạn.',
      },
    },
    'confirmed-no-route': {
      title: 'Bạn đã xác nhận giao hàng',
      subtitle: 'Vui lòng chờ thông tin',
      'for-date': 'vào {date}',
    },
    'not-confirmed': {
      form: {
        'empty-title': 'Hãy chắc chắn để lại chữ ký',
        'pharmacy-instruction-title': 'Hướng dẫn đặc biệt của nhà thuốc:',
        'recipient-instruction': {
          title: 'Hướng dẫn đặc biệt cho người nhận:',
          placeholder: 'Thêm hướng dẫn đặc biệt',
          'update-btn': 'Cập nhật',
        },
        sign: {
          description: 'Tài xế sẽ cố gắng giao trực tiếp. Nếu không có ai ở nhà, tài xế sẽ để gói hàng bên cửa và chụp hình.',
          confirm: {
            btn: 'Xác nhận giao hàng',
            title: 'Bạn có chắc không?',
            text: 'Tôi xác nhận rằng thông tin tôi cung cấp là chính xác và đúng sự thật',
          },
        },
      },
      progress: {
        attempts: 'Lần thử giao hàng:',
        created: 'Đơn hàng <br> đã tạo',
      },
      transit: 'Đang vận chuyển',
      'out-for-delivery': 'Đang <br> giao hàng',
      delivered: 'Đã giao',
      signature: {
        title: 'Ký bên dưới để cho phép bỏ gói hàng mà không cần chữ ký:',
        clear: 'Xóa',
      },
      statuses: {
        'at-pharmacy': 'Đơn hàng của bạn đang tại nhà thuốc và sẽ được giao',
        'driver-out': 'Xác nhận giao hàng',
        rescheduled: 'Giao hàng được lên lịch lại vào',
        'pending-back-to-pharmacy': 'Đơn hàng của bạn đang chờ trả lại nhà thuốc',
        'pickup-occured': 'Đơn hàng đã được lấy từ nhà thuốc và sẽ được giao',
      },
    },
    rescheduled: {
      attempted: 'Đã thử giao vào',
    },
  },
  investigation: {
    link_start: 'Vui lòng liên hệ với chúng tôi tại',
    link_end: 'để lên lịch giao hàng',
    instructions: 'Hướng dẫn đặc biệt của nhà thuốc:',
  },
  rescadule: {
    subtitle: 'Vui lòng chọn ngày giao hàng mới',
    'too-many': 'Không thể đổi lịch đơn hàng quá 3 lần. Vui lòng gọi {phone}',
    'wrong-address': 'Tài xế không tìm thấy địa chỉ của bạn. Vui lòng cung cấp địa chỉ chính xác.',
    'not-present': 'Tài xế đã đến địa chỉ của bạn nhưng không có ai mở cửa.',
  },
  rejected: {
    'back-to-pharmacy': {
      rejected: 'Đơn hàng đã bị nhà thuốc hủy',
      'pending-back-to-pharmacy': 'Đơn hàng của bạn đã bị hủy và đang chờ trả lại nhà thuốc',
      'on-its-way-to-pharmacy': 'Đơn hàng của bạn đã bị hủy và xác nhận trả lại nhà thuốc',
      default: 'Đơn hàng của bạn đã bị hủy và gửi trả lại nhà thuốc',
      'confirmed-back-to-pharmacy': 'Đơn hàng đã bị hủy, đang chờ xác nhận trả lại nhà thuốc',
      'back-to-pharmacy': 'Đơn hàng của bạn đã bị hủy và gửi trả lại nhà thuốc',
    },
  },
  returned: {
    'back-to-pharmacy': {
      title: 'Đơn hàng của bạn đang chờ trả lại nhà thuốc',
    },
  },
}
